import API from './api';

export const listAccidentReports = (params = {}) =>
  API.get('/accident-reports', { params });

export const createAccidentReport = (data) =>
  API.post('/accident-reports', data);

export const updateAccidentReport = (id, data) =>
  API.patch(`/accident-reports/${id}`, data);

export const listDriversForAccident = () =>
  API.get('/accident-reports/drivers');

export const listVehiclesForAccident = () =>
  API.get('/accident-reports/vehicles');

export const deleteAccidentReport = (id) =>
  API.delete(`/accident-reports/${id}`);

export const uploadAccidentAttachment = (id, formData) =>
  API.post(`/accident-reports/${id}/attachments`, formData);

export const getAttachmentLink = (reportId, attachmentId) =>
  API.get(`/accident-reports/${reportId}/attachments/${attachmentId}/link`);

export const deleteAccidentAttachment = (reportId, attachmentId) =>
  API.delete(`/accident-reports/${reportId}/attachments/${attachmentId}`);
